// YYYY-MM-DD in the visitor's local time zone, the format <input type="date"> uses.
export const toDateInputValue = (date: Date) => {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
};

export const getDateInputValueFromToday = (days = 0) => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return toDateInputValue(date);
};

export const getRestaurantWeekday = (date = new Date()) =>
  new Intl.DateTimeFormat('en-US', { weekday: 'long', timeZone: 'America/Toronto' }).format(date);

// Calendar date ("YYYY-MM-DD") in the restaurant's time zone.
export const getRestaurantDate = (date = new Date()) =>
  new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto' }).format(date);
